var cov_lf9eo95d5 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Upload/context.tsx",
      hash = "d0a44df568bde0927069b84f460e3e356d1fef68",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Upload/context.tsx",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 16
        },
        end: {
          line: 4,
          column: 50
        }
      },
      "1": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 7,
          column: 40
        }
      },
      "2": {
        start: {
          line: 9,
          column: 24
        },
        end: {
          line: 11,
          column: 1
        }
      },
      "3": {
        start: {
          line: 9,
          column: 57
        },
        end: {
          line: 11,
          column: 1
        }
      },
      "4": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 10,
          column: 82
        }
      },
      "5": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 10,
          column: 62
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 24
          },
          end: {
            line: 9,
            column: 25
          }
        },
        loc: {
          start: {
            line: 9,
            column: 57
          },
          end: {
            line: 11,
            column: 1
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 9,
            column: 57
          },
          end: {
            line: 9,
            column: 58
          }
        },
        loc: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 82
          }
        },
        line: 10
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 10,
            column: 21
          },
          end: {
            line: 10,
            column: 22
          }
        },
        loc: {
          start: {
            line: 10,
            column: 30
          },
          end: {
            line: 10,
            column: 62
          }
        },
        line: 10
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _this = this,
    _jsxFileName = "/Users/spana/SHEIN/shineout/src/Upload/context.tsx";

import React from 'react';
import createReactContext from '../context';
var context = (cov_lf9eo95d5.s[0]++, createReactContext(undefined)); // eslint-disable-next-line

export var Provider = (cov_lf9eo95d5.s[1]++, context.Provider);
cov_lf9eo95d5.s[2]++;
export var consumer = function consumer(Origin) {
  cov_lf9eo95d5.f[0]++;
  cov_lf9eo95d5.s[3]++;
  return function (props) {
    cov_lf9eo95d5.f[1]++;
    cov_lf9eo95d5.s[4]++;
    return (
      /*#__PURE__*/
      React.createElement(context.Consumer, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 10,
          columnNumber: 3
        }
      }, function (value) {
        cov_lf9eo95d5.f[2]++;
        cov_lf9eo95d5.s[5]++;
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, value, {
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 10,
              columnNumber: 31
            }
          }))
        );
      })
    );
  };
};